import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-rating-face-1",
  "use": "foquz-icon-rating-face-1-usage",
  "viewBox": "0 0 15 11",
  "content": "<symbol viewBox=\"0 0 15 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-rating-face-1\"><circle cx=\"11.5\" cy=\"2.5\" r=\"1.5\" fill=\"#fff\" /><circle cx=\"3.5\" cy=\"2.5\" r=\"1.5\" fill=\"#fff\" /><path d=\"M1 1l4 .8m9-.8l-4 .8m2 8.2a6.36 6.36 0 00-2.054-1.47A6.085 6.085 0 007.514 8a6.079 6.079 0 00-2.44.492A6.358 6.358 0 003 9.93\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol